(() => {
  const initProgressBars = (root = document) => {
    root.querySelectorAll('[data-cf-progress]').forEach((el) => {
      if (el.dataset.cfInitialised === '1') return;
      const fill = el.querySelector('[data-cf-fill]');
      if (!fill) return;
      const targetWidth = fill.dataset.targetWidth || '0%';
      fill.style.width = '0%';
      requestAnimationFrame(() => {
        el.classList.add('is-ready');
        fill.style.setProperty('--cf-fill-width', targetWidth);
        fill.style.width = targetWidth;
      });
      el.dataset.cfInitialised = '1';
    });
  };

  const initCountdowns = (root = document) => {
    root.querySelectorAll('#cf-countdown').forEach((el) => {
      if (el.dataset.cfInitialised === '1') return;
      const target = new Date(el.dataset.target);
      if (!el.dataset.target || Number.isNaN(target.getTime())) {
        el.hidden = true;
        return;
      }

      const daysEl = el.querySelector('[data-cf-days]');
      const hoursEl = el.querySelector('[data-cf-hours]');
      const minsEl = el.querySelector('[data-cf-mins]');
      const secsEl = el.querySelector('[data-cf-secs]');

      const pad = (n) => String(n).padStart(2, '0');
      const render = () => {
        const diff = target.getTime() - Date.now();
        if (diff <= 0) {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minsEl) minsEl.textContent = '00';
          if (secsEl) secsEl.textContent = '00';
          return false;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const mins = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(mins);
        if (secsEl) secsEl.textContent = pad(secs);
        return true;
      };

      render();
      const interval = window.setInterval(() => {
        if (!render()) {
          window.clearInterval(interval);
          el.hidden = true;
        }
      }, 1000);
      el.dataset.cfInitialised = '1';
    });
  };

  const initSellingPlanSelection = (root = document) => {
    root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.cfSellingPlanInitialised === '1') return;

      const radios = [...form.querySelectorAll('input[name="selling_plan"]')];
      const defaultRadio = radios.find((input) => !input.value);
      const activePlanId = (form.dataset.cfSellingPlanId || '').trim();
      const selectedPlanRadio = activePlanId
        ? radios.find((input) => input.value === activePlanId) || radios.find((input) => input.value)
        : radios.find((input) => input.value);

      if (selectedPlanRadio) {
        selectedPlanRadio.checked = true;
        if (defaultRadio) {
          defaultRadio.checked = false;
        }
        selectedPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      form.dataset.cfSellingPlanInitialised = '1';
    });
  };

  const initCrowdfundPdp = (root = document) => {
    initProgressBars(root);
    initCountdowns(root);
    initSellingPlanSelection(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCrowdfundPdp());
  } else {
    initCrowdfundPdp();
  }

  document.addEventListener('shopify:section:load', (event) => initCrowdfundPdp(event.target));
  document.addEventListener('shopify:section:select', (event) => initCrowdfundPdp(event.target));
})();
